
import $ from 'jquery'

export default {
	$ajax (options) {
		let endpoint = '//' + 'signage.staging.api.unoapp.io'
		options.url = endpoint + options.url
		options.beforeSend = (xhr) => {
		}
		$.ajax(options)
	}
}



// WEBPACK FOOTER //
// ./src/signageEndpoint.js